export default {
  EST_COCTAIL: 1,
  EST_CARAMBOL: 2,
  EST_ORANGE: 3,
  EST_GRAPE: 4,
  EST_STRAWBERRY: 5,
  EST_BLUEBERRY: 6,
  EST_APPLE: 7,
}
